import { WalletOverview, BuyDvxResponse } from "@/types/wallet";
import axiosInstance from "./axiosInstance";
import { AxiosResponse } from 'axios';


export class WalletService {
  private static readonly GET_WALLET_OVERVIEW = 'app/wallet/overview';
  private static readonly BUY_DVX_ENDPOINT = "/app/wallet/buy-dvx";

  public static async getWalletOverview(): Promise<WalletOverview> {
    const res: AxiosResponse<WalletOverview> = await axiosInstance.get(WalletService.GET_WALLET_OVERVIEW);
    return res.data;
  }

  public static async buyDvx(qty: number): Promise<BuyDvxResponse> {
    const res: AxiosResponse<BuyDvxResponse> = await axiosInstance.post(WalletService.BUY_DVX_ENDPOINT, { qty });
    return res.data;
  }
}
